import React, {useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
import {
  currentPerson,
  useFile,
  usePerson,
  usePersonView,
  usePrincipal,
  useQuote,
  useStripe
} from "@betrue/front/services";
import {File, Person, Quote, QuoteState, Scope, StripeAuthorize, SupplierQuote} from "@betrue/shared/interfaces";
import {AddQuoteView} from "./add-quote.view";
import {QuoteModalForm} from "./quote.form";
import {QuoteList} from "../quote-list/quote-list";

export const AddQuotePropsTypes = {
  openModalLabel: PropTypes.string,
  dialogTitle: PropTypes.string,
  dialogDescription: PropTypes.string,
  amountUntaxedLabel: PropTypes.string,
  amountLabel: PropTypes.string,
  referenceLabel: PropTypes.string,
  dropZoneLabel: PropTypes.string,
  dialogSubmit: PropTypes.string,
  dialogCancel: PropTypes.string,
  configurePaymentsLabel: PropTypes.string,
  configurePaymentsDescription: PropTypes.string

}

export type AddQuoteProps = InferProps<typeof AddQuotePropsTypes>

export const QUOTE_INITIAL_STATE: Quote = {
  file: undefined,
  removed: false,
  submitter: undefined,
  quoteDate: new Date(),
  amountUntaxed: 0,
  amount: 0,
  state: QuoteState.PENDING,
  reference: '',
  id: undefined,
  version: undefined
}

export const AddQuote = (props: AddQuoteProps) => {
  const [principal] = usePrincipal()
  const [file, {uploadQuoteFile, deleteFile}] = useFile<File>()
  const [person, {getPersonById}] = usePerson<Person>(currentPerson)

  const [viewPerson, viewProfile] = usePersonView()
  const [createdQuote, {createSupplierQuote}] = useQuote<Quote>()
  const [quotes, {supplierQuotes}] = useQuote<Quote[]>()
  const [authorizeUrl, {authorize}] = useStripe<StripeAuthorize>()

  const [openModal, setOpenModal] = useState<boolean>(false)
  const [quote, setQuote] = useState<Quote>(QUOTE_INITIAL_STATE)

  useEffect(() => {
    if (createdQuote && principal) {
      supplierQuotes(viewPerson.id)
    }
  }, [createdQuote])

  useEffect(() => {
    if (principal && principal.scope === Scope.PARTNER && !principal.stripeAccountId) {
      authorize()
    }
  }, [principal])


  const openCloseModal = () => {
    setOpenModal(!openModal)
  }

  useEffect(() => {
    setQuote({...quote, file: file})

  }, [file])

  const handleSubmit = (form: QuoteModalForm) => {
    createSupplierQuote({
      ...quote,
      submitter: {...(viewPerson ? viewPerson : principal)}, ...form,
      file: file ? {...file} : undefined
    } as SupplierQuote)
    setOpenModal(false)
  }

  useEffect(() => {
    if (!openModal) {
      setQuote(QUOTE_INITIAL_STATE)
    }
  }, [openModal])

  const handleQuoteDrop = (file) => {
    uploadQuoteFile(file)
  }

  useEffect(() => {
    if (!openModal) {
      setQuote(QUOTE_INITIAL_STATE)
    }
  }, [openModal])

  if (!quote || !principal) return (<></>)

  return (
    <AddQuoteView {...props} quote={quote}
                  enabled={([Scope.PARTNER, Scope.EMPLOYEE].includes(principal.scope) )}
                  currentPerson={principal}
                  authorizeUrl={authorizeUrl?.authorizeUrl}
                  onSubmit={handleSubmit}
                  onFileDrop={handleQuoteDrop}
                  onCloseModal={openCloseModal}
                  isOpen={openModal}
                  onOpenModal={openCloseModal}/>
  );
}


AddQuote.propTypes = AddQuotePropsTypes
